import PublicTable from "../singleton/public-table";

export default {

    getAll: PublicTable.getAll.bind(PublicTable),

    get: PublicTable.get.bind(PublicTable),

    getRaw: PublicTable.getRaw.bind(PublicTable),

    create: PublicTable.create.bind(PublicTable),

    update: PublicTable.update.bind(PublicTable),

    delete: PublicTable.delete.bind(PublicTable),

    getByOwner: PublicTable.getByOwner.bind(PublicTable),

    getFields: PublicTable.getFields.bind(PublicTable),

    getOwners: PublicTable.getOwners.bind(PublicTable),

    getSubstitutions: PublicTable.getSubstitutions.bind(PublicTable),

    getVisualName: PublicTable.getVisualName.bind(PublicTable),

    loadData: PublicTable.loadData.bind(PublicTable),

    getByMapping: PublicTable.getByMapping.bind(PublicTable),

    setOrder: PublicTable.setOrder.bind(PublicTable)

}